import { BrowserRouter, Route, Routes } from 'react-router';
import App from './features/app/App';
import { ErrorBoundary } from './features/app/ErrorBoundary';
import { NoMatch } from './features/app/NoMatch';
import { createRoot } from 'react-dom/client';
import { DEFAULT_LOCALE, main } from './configuration';
import { IntlProvider } from 'react-intl';
import { config } from './config';

// biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
const renderApplication = ({ locale, displayMessages }: { locale: string; displayMessages: any }) => {
    const container = document.getElementById('root');
    // biome-ignore lint/style/noNonNullAssertion: suppress out of convenience during migration to biome
    const root = createRoot(container!);

    root.render(
        <ErrorBoundary>
            <BrowserRouter>
                <IntlProvider defaultLocale={DEFAULT_LOCALE} locale={locale} messages={displayMessages}>
                    <Routes>
                        <Route path={'/*'} element={<App />} />
                        <Route path={'/error'} element={<NoMatch />} />
                        <Route path={'*'} element={<NoMatch />} />
                    </Routes>
                </IntlProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
};

const isDev = import.meta.env.DEV;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;

if ((isDev && config.enableMockServer) || isProdPreview) {
    import('../mocks/msw/browser').then(({ startWorker }) => startWorker()).then(() => main(renderApplication));
} else {
    void main(renderApplication);
}
